import { DatePicker, Select, Typography, Card, Space } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import React from 'react';

import { Registro } from '../types';

interface DateFilterProps {
  registros: Registro[];
  registrosFiltrados?: Registro[];
  periodo: string;
  setPeriodo: (periodo: string) => void;
  dateRange: {
    startDate: string;
    endDate: string;
  };
  setRangeStart: (date: Dayjs) => void;
  setRangeEnd: (date: Dayjs) => void;
  onDateChange: (startDate: Dayjs, endDate: Dayjs) => void;
  periodOptions?: { value: string; label: string }[];
}

const defaultPeriodos = [
  { value: '24', label: 'Últimas 24 horas' },
  { value: '7d', label: 'Últimos 7 días' },
  { value: '15d', label: 'Últimos 15 días' },
  { value: '30d', label: 'Últimos 30 días' },
  { value: 'Personalizado', label: 'Rango personalizado' },
];

const DateFilter: React.FC<DateFilterProps> = ({
  registros,
  registrosFiltrados,
  periodo,
  setPeriodo,
  dateRange,
  setRangeStart,
  setRangeEnd,
  onDateChange,
  periodOptions,
}) => {
  const periodos = periodOptions || defaultPeriodos;

  const handleRangeChange = (dates: [Dayjs | null, Dayjs | null] | null) => {
    if (dates && dates[0] && dates[1]) {
      setRangeStart(dates[0]);
      setRangeEnd(dates[1]);
      setPeriodo('Personalizado');
      onDateChange(dates[0], dates[1]);
    }
  };

  const disabledDate = (current: Dayjs) => {
    return current && current > dayjs().endOf('day');
  };

  const handlePeriodChange = (value: string) => {
    setPeriodo(value);
  };

  return (
    <Card
      variant="outlined"
      styles={{ body: { padding: '16px' } }}
      style={{ marginBottom: '24px', borderRadius: '12px', border: 'none', maxWidth: '100%' }}
    >
      {/* <Typography.Title level={2} style={{ margin: 0, marginBottom: 12, color: '#0050b3', fontWeight: 700, fontSize: 34, letterSpacing: 0.2, fontFamily: 'Roboto, Helvetica Neue, Arial, sans-serif' }}>
        REGISTROS
      </Typography.Title> */}
      <Space>
        <Select
          value={periodo}
          onChange={handlePeriodChange}
          style={{ width: 180 }}
          options={periodos.map(p => ({ label: p.label, value: p.value }))}
        />
        {periodo === 'Personalizado' && (
          <DatePicker.RangePicker
            value={
              dateRange.startDate && dateRange.endDate
                ? [dayjs(dateRange.startDate), dayjs(dateRange.endDate)]
                : undefined
            }
            onChange={handleRangeChange}
            allowClear={false}
            style={{ minWidth: 220 }}
            format="YYYY-MM-DD"
            disabledDate={disabledDate}
          />
        )}
      </Space>
      <Typography.Text type="secondary" style={{ marginTop: 8, display: 'block' }}>
        {typeof registrosFiltrados !== 'undefined'
          ? `Mostrando ${registrosFiltrados.length} de ${registros.length} registros`
          : `Mostrando ${registros.length} registros`}
      </Typography.Text>
    </Card>
  );
};

export default DateFilter;
